var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultLogoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36345 8.66667V11.3333M10.7262 7.33333V11.3333M8.04484 4.66667V11.3333M5.22938 14H10.8603C11.9866 14 12.5497 14 12.9799 13.782C13.3583 13.5903 13.666 13.2843 13.8588 12.908C14.078 12.4802 14.078 11.9201 14.078 10.8V5.2C14.078 4.0799 14.078 3.51984 13.8588 3.09202C13.666 2.71569 13.3583 2.40973 12.9799 2.21799C12.5497 2 11.9866 2 10.8603 2H5.22938C4.1031 2 3.53995 2 3.10977 2.21799C2.73136 2.40973 2.42371 2.71569 2.23091 3.09202C2.01172 3.51984 2.01172 4.0799 2.01172 5.2V10.8C2.01172 11.9201 2.01172 12.4802 2.23091 12.908C2.42371 13.2843 2.73136 13.5903 3.10977 13.782C3.53995 14 4.1031 14 5.22938 14Z",
    stroke: "#A39992",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultLogoOff);
export default __webpack_public_path__ + "static/media/Result-logo-off.8ff12398c1355121d1e595de6b93d65e.svg";
export { ForwardRef as ReactComponent };